type Rgb = { r: number; g: number; b: number };

function hexToRgb(hex: string): Rgb | null {
  const cleaned = hex.trim().replace(/^#/, "");
  const full =
    cleaned.length === 3
      ? cleaned
          .split("")
          .map((c) => c + c)
          .join("")
      : cleaned;

  if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;

  const num = parseInt(full, 16);
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

/**
 * Blends `base` toward `mix` by `weight` (0–1) and returns an `rgb(...)` string
 * — e.g. mixColors("#ffffff", "#000000", 0.1) darkens white by 10% (light theme)
 * and mixColors("#18181b", "#ffffff", 0.1) lightens the dark surface by 10%.
 * Returns `base` unchanged when it isn't a parseable hex color.
 */
export function mixColors(base: string, mix: string, weight: number): string {
  const a = hexToRgb(base);
  const b = hexToRgb(mix);
  if (!a || !b) return base;

  const w = Math.min(1, Math.max(0, weight));
  const blend = (x: number, y: number) =>
    Math.min(255, Math.max(0, Math.round(x * (1 - w) + y * w)));

  return `rgb(${blend(a.r, b.r)}, ${blend(a.g, b.g)}, ${blend(a.b, b.b)})`;
}
